export default {"src":"/_next/static/media/TPO-financiers.e41b2f00.svg","height":1600,"width":1600};